import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { containerVariants, fadeUpVariants } from '../lib/motion';
import { VERTICALS } from '../mock';

export default function Verticals() {
  return (
    <section className="section-pad bg-brand-lavender">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-14">
          <h2 className="heading-display text-3xl md:text-5xl text-brand-dark">Our Mobility Verticals</h2>
          <p className="mt-3 text-brand-dark/65 max-w-2xl mx-auto">
            One EV platform. Three mobility verticals built for how India moves.
          </p>
        </div>

        <motion.div 
          variants={containerVariants(0.1)}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-5xl mx-auto gap-5"
        >
          {VERTICALS.map((v) => {
            const Icon = v.icon;
            const isProduct = v.image.includes('scooter_green') || v.image.includes('scooter_black') || v.image.includes('campus_cart_single');
            return (
              <motion.div key={v.id} variants={fadeUpVariants(30, 0.7)}>
                <div className="group relative bg-white rounded-3xl p-5 border border-brand-dark/5 shadow-sm hover:shadow-xl hover:shadow-brand-lime/10 hover:border-brand-lime/30 hover:-translate-y-2 hover:scale-[1.01] transition-all duration-300 flex flex-col h-full">
                  {v.badge && (
                    <span className="absolute top-3 right-3 z-10 bg-brand-lime text-brand-dark text-xs font-semibold px-3 py-1 rounded-full">
                      {v.badge}
                    </span>
                  )}
                  <div className={`relative h-56 rounded-2xl overflow-hidden ${isProduct ? 'bg-white p-4' : 'bg-gradient-to-br from-brand-mint to-brand-lavenderSoft'}`}>
                    <img 
                      src={v.image} 
                      alt={v.title} 
                      className={`w-full h-full ${isProduct ? 'object-contain' : 'object-cover'} group-hover:scale-105 transition-transform duration-500`} 
                    />
                  </div>
                  <div className="flex items-center gap-2 mt-5">
                    <span className="w-8 h-8 rounded-lg bg-brand-mint flex items-center justify-center text-brand-dark">
                      <Icon size={16} />
                    </span>
                    <h3 className="heading-display text-xl text-brand-dark">{v.title}</h3>
                  </div>
                  <p className="text-sm font-medium text-brand-green mt-2">{v.tagline}</p>
                  <p className="text-sm text-brand-dark/65 mt-2 leading-relaxed">{v.description}</p>
                  <Link to={`/mobility-verticals#${v.id}`} className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-dark hover:text-brand-green transition-colors mt-auto pt-2">
                    {v.cta} <ArrowRight size={14} />
                  </Link>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
